import * as tslib_1 from "tslib";
import { Base } from '../../components/base-component';
import './form-item-business-awards.component.scss';
import { ProvincialCityService } from '../sa-provincial-city/sa-provincial-city.service';
var FormItemBusinessAwards = /** @class */ (function (_super) {
    tslib_1.__extends(FormItemBusinessAwards, _super);
    // radio values
    function FormItemBusinessAwards(element) {
        return _super.call(this, element) || this;
    }
    FormItemBusinessAwards.prototype.init = function () {
        this.form = this.element.querySelector("form");
        this.wizard = this.element.querySelector(".form-container-wizard__wizard");
        this.buttonSubmit = this.element.querySelector(".js-businessAwards__submit");
        this.yearCompanyFound = this.form.querySelector("input[name='yearCompanyFound']");
        this.companyOperatingSector = this.form.querySelector("select[name='companyOperatingSector']");
        this.companyOperatingSecOtherCont = this.form.querySelector(".company-operating-sector-other");
        // display views
        if (this.form) {
            this.displayLoader = this.form.querySelector(".form-container__loader");
            this.displayFields = this.form.querySelector(".form-container__fields");
            this.displaySuccess = this.form.querySelector(".form-container__success");
            this.displayError = this.form.querySelector('.form-container__error');
        }
        this.businessIsProfitable = "";
        this.businessIsProfitable2nd = "";
        this.businessHasSocialImpact = "";
        this.businessHasSocialImpact2nd = "";
        this.provincialCityService = ProvincialCityService.getInstance();
    };
    FormItemBusinessAwards.prototype.bindEvents = function () {
        var _this = this;
        if (this.buttonSubmit) {
            this.buttonSubmit.addEventListener("click", function (pEvent) {
                var _button = pEvent.target;
                var _form = _button.closest("form");
                var formFields = _form.querySelectorAll("input, select, textarea");
                _this.validationService.validate(formFields);
                var valid = Array.from(_form.querySelectorAll(".form__group--error"));
                if (valid.length === 0) {
                    _this.submitForm(_form);
                }
            });
        }
        // This adds slashes to the business registration number
        var businessReg = this.element.querySelector(".form__input--busReg");
        if (businessReg) {
            businessReg.addEventListener("input", function (pEvent) {
                if ((pEvent.inputType !== "deleteContentBackward") && (pEvent.inputType !== "deleteContentForward")) {
                    var reg = pEvent.target.value;
                    pEvent.target.value = _this.validationService.formatBusinessReg(reg);
                }
            });
            businessReg.addEventListener("blur", function (pEvent) {
                var reg = pEvent.target.value;
                pEvent.target.value = _this.validationService.formatExpression(reg);
            });
        }
        if (this.yearCompanyFound) {
            this.yearCompanyFound.addEventListener("blur", function (pEvent) {
                if (!_this.validateYearField(_this.yearCompanyFound)) {
                    pEvent.stopImmediatePropagation();
                }
            });
        }
        if (this.companyOperatingSector) {
            this.companyOperatingSector.addEventListener("change", function () { return _this.displayCompanyOpSecOther(_this.companyOperatingSector.value); });
        }
        var businessIsProfitable = Array.from(this.form.querySelectorAll("input[name='businessIsProfitable']"));
        var businessIsProfitable2nd = Array.from(this.form.querySelectorAll("input[name='businessIsProfitable2nd']"));
        if (businessIsProfitable) {
            businessIsProfitable.map(function (item) { return item.addEventListener("click", function (event) {
                var evt = event.target;
                _this.businessIsProfitable = evt.value;
                var _businessIsProfitable2ndNo = businessIsProfitable2nd[0];
                var _businessIsProfitable2ndYes = businessIsProfitable2nd[1];
                if (_this.businessIsProfitable === 'NO') {
                    _this.businessIsProfitable2nd = 'NO';
                    _businessIsProfitable2ndNo.checked = true;
                }
                if (_this.businessIsProfitable === 'YES') {
                    _this.businessIsProfitable2nd = 'YES';
                    _businessIsProfitable2ndYes.checked = true;
                }
            }); });
        }
        if (businessIsProfitable2nd) {
            businessIsProfitable2nd.map(function (item) { return item.addEventListener("click", function (event) {
                var evt = event.target;
                _this.businessIsProfitable2nd = evt.value;
                var _businessIsProfitableNo = businessIsProfitable[0];
                var _businessIsProfitableYes = businessIsProfitable[1];
                if (_this.businessIsProfitable2nd === 'NO') {
                    _this.businessIsProfitable = 'NO';
                    _businessIsProfitableNo.checked = true;
                }
                if (_this.businessIsProfitable2nd === 'YES') {
                    _this.businessIsProfitable = 'YES';
                    _businessIsProfitableYes.checked = true;
                }
            }); });
        }
        var businessHasSocialImpact = Array.from(this.form.querySelectorAll("input[name='businessHasSocialImpact']"));
        var businessHasSocialImpact2nd = Array.from(this.form.querySelectorAll("input[name='businessHasSocialImpact2nd']"));
        if (businessHasSocialImpact) {
            businessHasSocialImpact.map(function (item) { return item.addEventListener("click", function (event) {
                var evt = event.target;
                _this.businessHasSocialImpact = evt.value;
                _this.showHideSocialImpactExample(_this.businessHasSocialImpact);
                var _businessHasSocialImpact2ndNo = businessHasSocialImpact2nd[0];
                var _businessHasSocialImpact2ndYes = businessHasSocialImpact2nd[1];
                if (_this.businessHasSocialImpact === 'NO') {
                    _this.businessHasSocialImpact2nd = 'NO';
                    _businessHasSocialImpact2ndNo.checked = true;
                }
                if (_this.businessHasSocialImpact === 'YES') {
                    _this.businessHasSocialImpact2nd = 'YES';
                    _businessHasSocialImpact2ndYes.checked = true;
                }
            }); });
        }
        if (businessHasSocialImpact2nd) {
            businessHasSocialImpact2nd.map(function (item) { return item.addEventListener("click", function (event) {
                var evt = event.target;
                _this.businessHasSocialImpact2nd = evt.value;
                _this.showHideSocialImpactExample(_this.businessHasSocialImpact2nd);
                var _businessHasSocialImpactNo = businessHasSocialImpact[0];
                var _businessHasSocialImpactYes = businessHasSocialImpact[1];
                if (_this.businessHasSocialImpact2nd === 'NO') {
                    _this.businessHasSocialImpact = 'NO';
                    _businessHasSocialImpactNo.checked = true;
                }
                if (_this.businessHasSocialImpact2nd === 'YES') {
                    _this.businessHasSocialImpact = 'YES';
                    _businessHasSocialImpactYes.checked = true;
                }
            }); });
        }
        if (this.form) {
            var _formFields = Array.from(this.form.querySelectorAll("input, select, textarea"));
            if (_formFields) {
                _formFields.forEach(function (pEement) {
                    pEement.addEventListener("blur", function (pEvent) {
                        _this.validateRadioInput(pEement);
                        _this.validationService.validateBlur(pEvent.currentTarget);
                    });
                });
            }
        }
        // Reset the form
        this.form.addEventListener("custom_form_reset_event", function (pEvent) {
            if (_this.wizard) {
                var event_1 = new CustomEvent("custom_wizard_reset_event");
                _this.wizard.dispatchEvent(event_1);
            }
            _this.showDisplayView("");
        }, false);
        this.initCustomFormElement();
        this.populateProvinces();
    };
    FormItemBusinessAwards.prototype.submitForm = function (pForm) {
        var _this = this;
        var _applicantName = pForm.querySelector(".form-container__success__applicantName");
        // first screen
        var businessIsProfitable = pForm.querySelector("input[name='businessIsProfitable']");
        var businessHasSocialImpact = pForm.querySelector("input[name='businessHasSocialImpact']");
        var businessHasRegisteredCipc = pForm.querySelector("input[name='businessHasRegisteredCipc']");
        var businessHasIntentToScale = pForm.querySelector("input[name='businessHasIntentToScale']");
        var businessRequiresFunding = pForm.querySelector("input[name='businessRequiresFunding']");
        var mainOperationInSa = pForm.querySelector("input[name='mainOperationInSa']");
        var companyDirectorSaCitizen = pForm.querySelector("input[name='companyDirectorSaCitizen']");
        var companyIs3YearOperation = pForm.querySelector("input[name='companyIs3YearOperation']");
        // second screen
        var firstName = pForm.querySelector("input[name='firstName']");
        var lastName = pForm.querySelector("input[name='lastName']");
        var emailAddress = pForm.querySelector("input[name='emailAddress']");
        var contactNumber = pForm.querySelector("input[name='contactNumber']");
        var ethnicity = pForm.querySelector("select[name='ethnicity']");
        var gender = pForm.querySelector("input[name='gender']");
        var southAfricanCitizen = pForm.querySelector("input[name='southAfricanCitizen']");
        var sbsaCustomer = pForm.querySelector("input[name='sbsaCustomer']");
        var likeUsToContactYou = pForm.querySelector("input[name='likeUsToContactYou']");
        var acceptTermAndConditions = pForm.querySelector("input[name='acceptTermAndConditions']");
        var confirmProvidedInfoTrue = pForm.querySelector("input[name='confirmProvidedInfoTrue']");
        // third screen
        var companyName = pForm.querySelector("input[name='companyName']");
        var coregNumber = pForm.querySelector("input[name='coregNumber']");
        var businessAddress = pForm.querySelector("input[name='businessAddress']");
        var businessAddressProvince = pForm.querySelector("select[name='businessAddressProvince']");
        var businessAddressCity = pForm.querySelector("input[name='businessAddressCity']");
        var websiteAddress = pForm.querySelector("input[name='websiteAddress']");
        var yearCompanyFound = pForm.querySelector("input[name='yearCompanyFound']");
        var anuualTurnover = pForm.querySelector("input[name='anuualTurnover']");
        var companyOperatingSector = pForm.querySelector("select[name='companyOperatingSector']");
        var companyOperatingSecOther = this.form.querySelector("input[name='companyOperatingSectorOther']");
        var businessIsProfitable2nd = pForm.querySelector("input[name='businessIsProfitable2nd']");
        var businessHasSocialImpact2nd = pForm.querySelector("input[name='businessHasSocialImpact2nd']");
        var exampleOfSocialImpact = pForm.querySelector("textarea[name='exampleOfSocialImpact']");
        var howToUseAwardMoney = pForm.querySelector("textarea[name='howToUseAwardMoney']");
        // fourth screen
        var requiredFundingAmount = pForm.querySelector("input[name='requiredFundingAmount']");
        var whatsUniqueAboutBusiness = pForm.querySelector("textarea[name='whatsUniqueAboutBusiness']");
        var problemsInCompany = pForm.querySelector("textarea[name='problemsInCompany']");
        var revenueModel = pForm.querySelector("textarea[name='revenueModel']");
        var targetMarket = pForm.querySelector("textarea[name='targetMarket']");
        var competitors = pForm.querySelector("textarea[name='competitors']");
        var companyLeadership = pForm.querySelector("textarea[name='companyLeadership']");
        var companyOperatingSectorVal = '';
        console.log(companyOperatingSectorVal);
        console.log(companyOperatingSector);
        console.log(companyOperatingSecOther);
        if (companyOperatingSector) {
            console.log(companyOperatingSector.value);
            companyOperatingSectorVal = companyOperatingSector.value;
            if (companyOperatingSector.value === 'Other') {
                if (companyOperatingSecOther) {
                    companyOperatingSectorVal = companyOperatingSecOther.value;
                }
            }
        }
        var _postData = {
            // screen 1
            'businessIsProfitable': this.getFieldValue(businessIsProfitable),
            'businessHasSocialImpact': this.getFieldValue(businessHasSocialImpact),
            'businessHasRegisteredCipc': this.getFieldValue(businessHasRegisteredCipc),
            'businessHasIntentToScale': this.getFieldValue(businessHasIntentToScale),
            'businessRequiresFunding': this.getFieldValue(businessRequiresFunding),
            'mainOperationInSa': this.getFieldValue(mainOperationInSa),
            'companyDirectorSaCitizen': this.getFieldValue(companyDirectorSaCitizen),
            'companyIs3YearOperation': this.getFieldValue(companyIs3YearOperation),
            // screen 2
            'firstName': this.getFieldValue(firstName),
            'lastName': this.getFieldValue(lastName),
            'emailAddress': this.getFieldValue(emailAddress),
            'contactNumber': this.getFieldValue(contactNumber),
            'ethnicity': this.getFieldValue(ethnicity),
            'gender': this.getFieldValue(gender),
            'southAfricanCitizen': this.getFieldValue(southAfricanCitizen),
            'sbsaCustomer': this.getFieldValue(sbsaCustomer),
            'likeUsToContactYou': this.getFieldValue(likeUsToContactYou),
            'acceptTermAndConditions': this.getFieldValue(acceptTermAndConditions),
            'confirmProvidedInfoTrue': this.getFieldValue(confirmProvidedInfoTrue),
            // screen 3
            'companyName': this.getFieldValue(companyName),
            'coregNumber': this.getFieldValue(coregNumber),
            'businessAddress': this.getFieldValue(businessAddress) + " " + this.getFieldValue(businessAddressCity) + " " + this.getFieldValue(businessAddressProvince),
            'websiteAddress': this.getFieldValue(websiteAddress),
            'yearCompanyFound': this.getFieldValue(yearCompanyFound),
            'anuualTurnover': this.getFieldValue(anuualTurnover),
            'companyOperatingSector': companyOperatingSectorVal,
            'businessIsProfitable2nd': this.getFieldValue(businessIsProfitable2nd),
            'companyHasSocialImpact2nd': this.getFieldValue(businessHasSocialImpact2nd),
            'exampleOfSocialImpact': this.getFieldValue(exampleOfSocialImpact),
            'howToUseAwardMoney': this.getFieldValue(howToUseAwardMoney),
            // screen 4
            'requiredFundingAmount': this.getFieldValue(requiredFundingAmount),
            'whatsUniqueAboutBusiness': this.getFieldValue(whatsUniqueAboutBusiness),
            'problemsInCompany': this.getFieldValue(problemsInCompany),
            'revenueModel': this.getFieldValue(revenueModel),
            'targetMarket': this.getFieldValue(targetMarket),
            'competitors': this.getFieldValue(competitors),
            'companyLeadership': this.getFieldValue(companyLeadership),
        };
        this.showDisplayView("loader");
        // variables
        var url = this.baseUrl + "/sites/services/BusinessAwardsApplicationForm.jsp";
        var config = {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
                'Access-Control-Allow-Origin': '*',
                'X-Requested-With': 'XMLHttpRequest'
            }
        };
        var awardsPayload = "bussinessAwardsApplicationPayload=" + JSON.stringify(_postData);
        // service
        this.formsService.postForm(url, awardsPayload, config).then(function (pResponse) {
            if (pResponse) {
                if (pResponse.data) {
                    if (!pResponse.data.validationFlag) {
                        _this.analyticsService.dtmFormComplete("complete", pResponse.code);
                        _this.showDisplayView("success");
                    }
                    else {
                        _this.analyticsService.dtmRecordSiteError("noerrorcode|invalid fields|" + url);
                        _this.showDisplayView("error");
                    }
                }
                else {
                    _this.analyticsService.dtmRecordSiteError("noerrorcode|invalid fields|" + url);
                    _this.showDisplayView("error");
                }
            }
            else {
                _this.analyticsService.dtmRecordSiteError("noerrorcode|invalid fields|" + url);
                _this.showDisplayView("error");
            }
        }).catch(function (pError) {
            // service failed
            _this.analyticsService.dtmRecordSiteError("noerrorcode|service failure occured|" + url);
            _this.showDisplayView("error");
        });
    };
    FormItemBusinessAwards.prototype.showDisplayView = function (pDisplay) {
        this.displayLoader.classList.add("hidden");
        this.displayFields.classList.add("hidden");
        this.displaySuccess.classList.add("hidden");
        this.displayError.classList.add("hidden");
        switch (pDisplay) {
            case "success":
                this.displaySuccess.classList.remove("hidden");
                break;
            case "error":
                this.displayError.classList.remove("hidden");
                break;
            case "loader":
                this.displayLoader.classList.remove("hidden");
                break;
            default:
                this.displayFields.classList.remove("hidden");
                break;
        }
    };
    FormItemBusinessAwards.prototype.getFieldValue = function (field) {
        if (field) {
            if (field.type === "checkbox") {
                return field.checked ? "YES" : "NO";
            }
            else if (field.type === "radio") {
                var checkedField = this.form.querySelector("input[name=" + field.name + "]:checked");
                return checkedField ? checkedField.value : field.value;
            }
            else {
                return field.value;
            }
        }
        return "";
    };
    FormItemBusinessAwards.prototype.validateFormStepRadios = function (stepId) {
        var _this = this;
        var allRadiosInStepSelector = "div[data-step='" + stepId + "']" + " input[type=radio]";
        var _radios = Array.from(this.form.querySelectorAll(allRadiosInStepSelector));
        var tracker = new Map();
        var isStepValid = true;
        _radios.forEach(function (radio) {
            var radios;
            if (!tracker.get(radio.name)) {
                radios = new Array();
                radios.push(radio);
                tracker.set(radio.name, radios);
            }
            else {
                radios = tracker.get(radio.name);
                radios.push(radio);
            }
        });
        Array.from(tracker.keys()).forEach(function (key) {
            var _targetRadios = tracker.get(key);
            var isValid = false;
            var targetElement = null;
            _targetRadios.forEach(function (r) {
                targetElement = r;
                if (targetElement.checked) {
                    isValid = true;
                }
            });
            _this.removeError(targetElement);
            if (!isValid) {
                _this.addError(targetElement, null);
                isStepValid = false;
            }
        });
        return isStepValid;
    };
    FormItemBusinessAwards.prototype.validateRadioInput = function (field) {
        if (field.type !== "radio") {
            return true;
        }
        var _radios = Array.from(this.form.querySelectorAll("input[name=" + field.name + "]"));
        var isValid = false;
        _radios.forEach(function (r) {
            if (r.checked) {
                isValid = true;
            }
        });
        if (isValid) {
            this.removeError(field);
        }
        else {
            this.removeError(field);
        }
    };
    FormItemBusinessAwards.prototype.displayCompanyOpSecOther = function (value) {
        if (this.companyOperatingSecOtherCont) {
            if (value === "Other") {
                this.companyOperatingSecOtherCont.classList.remove('form__group--hidden');
            }
            else {
                this.companyOperatingSecOtherCont.classList.add('form__group--hidden');
            }
        }
    };
    FormItemBusinessAwards.prototype.validateYearField = function (field) {
        var isValid = true;
        var fieldGroup = field.closest(".form__group");
        var year = Number.parseInt(field.value);
        var yearRegex = /^[0-9]*$/;
        if (fieldGroup) {
            fieldGroup.classList.remove('form__group--error');
            var errorMessage = fieldGroup.querySelector('.form__group--error_message');
            if (errorMessage) {
                errorMessage.remove();
            }
        }
        if (!fieldGroup.classList.contains("form__group--hidden")) {
            var _yearValue = field.value;
            if (_yearValue === "") {
                isValid = false;
                fieldGroup.closest(".form__group").classList.add("form__group--error");
                var _errorDiv = document.createElement("div");
                _errorDiv.classList.add("form__group--error_message");
                var _errors = document.createElement("ul");
                _errorDiv = document.createElement("div");
                _errorDiv.classList.add("form__group--error_message");
                var _error = document.createElement("li");
                _error.innerHTML = 'This field is required';
                _errors.appendChild(_error);
                _errorDiv.appendChild(_errors);
                fieldGroup.appendChild(_errorDiv);
            }
            else if (!yearRegex.test(field.value)) {
                isValid = false;
                fieldGroup.closest(".form__group").classList.add("form__group--error");
                var _errorDiv = document.createElement("div");
                _errorDiv.classList.add("form__group--error_message");
                var _errors = document.createElement("ul");
                _errorDiv = document.createElement("div");
                _errorDiv.classList.add("form__group--error_message");
                var _error = document.createElement("li");
                _error.innerHTML = 'This field is invalid';
                _errors.appendChild(_error);
                _errorDiv.appendChild(_errors);
                fieldGroup.appendChild(_errorDiv);
            }
            else if (isNaN(year)) {
                isValid = false;
                fieldGroup.closest(".form__group").classList.add("form__group--error");
                var _errorDiv = document.createElement("div");
                _errorDiv.classList.add("form__group--error_message");
                var _errors = document.createElement("ul");
                _errorDiv = document.createElement("div");
                _errorDiv.classList.add("form__group--error_message");
                var _error = document.createElement("li");
                _error.innerHTML = 'This field is invalid';
                _errors.appendChild(_error);
                _errorDiv.appendChild(_errors);
                fieldGroup.appendChild(_errorDiv);
            }
            else {
                if (year < 1800 || year > 2021) {
                    isValid = false;
                    fieldGroup.closest(".form__group").classList.add("form__group--error");
                    var _errorDiv = document.createElement("div");
                    _errorDiv.classList.add("form__group--error_message");
                    var _errors = document.createElement("ul");
                    _errorDiv = document.createElement("div");
                    _errorDiv.classList.add("form__group--error_message");
                    var _error = document.createElement("li");
                    _error.innerHTML = 'This year is not acceptable';
                    _errors.appendChild(_error);
                    _errorDiv.appendChild(_errors);
                    fieldGroup.appendChild(_errorDiv);
                }
            }
        }
        return isValid;
    };
    FormItemBusinessAwards.prototype.validateTextField = function (field, regexString, regexMessage, emptyMessage) {
        if (field) {
            var reg = new RegExp(regexString);
            var _val = field.value;
            if (emptyMessage && !_val) {
                var isErrorRemoved = this.removeError(field);
                while (isErrorRemoved) {
                    isErrorRemoved = this.removeError(field);
                }
                this.addError(field, emptyMessage);
                return false;
            }
            else if (regexString && regexMessage) {
                if (!reg.test(_val)) {
                    var _tVal = reg.test(_val);
                    var isErrorRemoved = this.removeError(field);
                    while (isErrorRemoved) {
                        isErrorRemoved = this.removeError(field);
                    }
                    this.addError(field, regexMessage);
                    return false;
                }
            }
            else {
                var isErrorRemoved = this.removeError(field);
                while (isErrorRemoved) {
                    isErrorRemoved = this.removeError(field);
                }
            }
        }
        return true;
    };
    FormItemBusinessAwards.prototype.formatBusinessRegsadfas = function (event) {
        var _stringLength = parseFloat(event.length);
        var _newLength = (_stringLength - 1);
        var _check = event.substring(_newLength);
        var reg = new RegExp('^[0-9]+$');
        if (reg.test(_check)) {
            if (event.length === 4) {
                event = event += '/';
            }
            else if (event.length === 11) {
                event = event += '/';
            }
            else if (event.length > 14) {
                event = event.substring(0, 14);
            }
        }
        else {
            return event.substring(0, _newLength);
        }
        return event;
    };
    FormItemBusinessAwards.prototype.addError = function (field, errorMessage) {
        var fieldErrorDetail = errorMessage;
        if (!fieldErrorDetail) {
            fieldErrorDetail = "This field is required";
        }
        var containingDiv = field.closest(".form__group");
        containingDiv.classList.add("form__group--error");
        var _errorDiv = document.createElement("div");
        _errorDiv.classList.add("form__group--error_message");
        var _errors = document.createElement("ul");
        _errorDiv = document.createElement("div");
        _errorDiv.classList.add("form__group--error_message");
        var _error = document.createElement("li");
        _error.innerHTML = fieldErrorDetail;
        _errors.appendChild(_error);
        _errorDiv.appendChild(_errors);
        containingDiv.appendChild(_errorDiv);
    };
    FormItemBusinessAwards.prototype.removeError = function (field) {
        var containingDiv = field.closest(".form__group");
        if (containingDiv.classList.contains("form__group--error")) {
            containingDiv.classList.remove("form__group--error");
            containingDiv.removeChild(containingDiv.lastChild);
            return true;
        }
        return false;
    };
    FormItemBusinessAwards.prototype.showHideSocialImpactExample = function (_value) {
        if (_value === "YES") {
            this.element.querySelector(".js-social-impact-descr").classList.remove('form__group--hidden');
        }
        else {
            this.element.querySelector(".js-social-impact-descr").classList.add('form__group--hidden');
            var exampleOfSocialImpact = this.form.querySelector("textarea[name=exampleOfSocialImpact]");
            exampleOfSocialImpact.value = "";
        }
    };
    FormItemBusinessAwards.prototype.initCustomFormElement = function () {
        var _this = this;
        // modifiers: `js-businessAwards__submit nextBtn step4`,
        var nextButtons = Array.from(this.form.querySelectorAll(".nextBtn"));
        nextButtons.forEach(function (btn) {
            btn.addEventListener("click", function (event) {
                var _div = btn.closest("div");
                var stepId = Number(_div.getAttribute("data-step")) - 1;
                var _isValid = _this.validateFormStepRadios("" + stepId);
                if (!_isValid) {
                    event.stopImmediatePropagation(); // Stop from going to next step
                }
            });
        });
        // first screen
        var businessIsProfitable = this.form.querySelector("input[name='businessIsProfitable']");
        var businessHasSocialImpact = this.form.querySelector("input[name='businessHasSocialImpact']");
        var businessHasRegisteredCipc = this.form.querySelector("input[name='businessHasRegisteredCipc']");
        var businessHasIntentToScale = this.form.querySelector("input[name='businessHasIntentToScale']");
        var businessRequiresFunding = this.form.querySelector("input[name='businessRequiresFunding']");
        var mainOperationInSa = this.form.querySelector("input[name='mainOperationInSa']");
        var companyDirectorSaCitizen = this.form.querySelector("input[name='companyDirectorSaCitizen']");
        var companyIs3YearOperation = this.form.querySelector("input[name='companyIs3YearOperation']");
        // second screen
        var firstName = this.form.querySelector("input[name='firstName']");
        firstName.setAttribute("maxlength", "50");
        var lastName = this.form.querySelector("input[name='lastName']");
        lastName.setAttribute("maxlength", "50");
        var emailAddress = this.form.querySelector("input[name='emailAddress']");
        emailAddress.setAttribute("maxlength", "50");
        var contactNumber = this.form.querySelector("input[name='contactNumber']");
        var ethnicity = this.form.querySelector("select[name='ethnicity']");
        var gender = this.form.querySelector("input[name='gender']");
        var southAfricanCitizen = this.form.querySelector("input[name='southAfricanCitizen']");
        var sbsaCustomer = this.form.querySelector("input[name='sbsaCustomer']");
        var likeUsToContactYou = this.form.querySelector("input[name='likeUsToContactYou']");
        var acceptTermAndConditions = this.form.querySelector("input[name='acceptTermAndConditions']");
        var confirmProvidedInfoTrue = this.form.querySelector("input[name='confirmProvidedInfoTrue']");
        // third screen
        var companyName = this.form.querySelector("input[name='companyName']");
        companyName.setAttribute("maxlength", "50");
        var coregNumber = this.form.querySelector("input[name='coregNumber']");
        var businessAddress = this.form.querySelector("input[name='businessAddress']");
        businessAddress.setAttribute("maxlength", "50");
        var websiteAddress = this.form.querySelector("input[name='websiteAddress']");
        websiteAddress.setAttribute("maxlength", "50");
        var yearCompanyFound = this.form.querySelector("input[name='yearCompanyFound']");
        yearCompanyFound.setAttribute("minlength", "4");
        var anuualTurnover = this.form.querySelector("input[name='anuualTurnover']");
        anuualTurnover.setAttribute("maxlength", "18");
        var companyOperatingSector = this.form.querySelector("select[name='companyOperatingSector']");
        var businessIsProfitable2nd = this.form.querySelector("input[name='businessIsProfitable2nd']");
        var companyHasSocialImpact2nd = this.form.querySelector("input[name='businessHasSocialImpact2nd']");
        var exampleOfSocialImpact = this.form.querySelector("textarea[name='exampleOfSocialImpact']");
        exampleOfSocialImpact.setAttribute("maxlength", "249");
        var howToUseAwardMoney = this.form.querySelector("textarea[name='howToUseAwardMoney']");
        howToUseAwardMoney.setAttribute("maxlength", "249");
        // fourth screen
        var requiredFundingAmount = this.form.querySelector("input[name='requiredFundingAmount']");
        requiredFundingAmount.setAttribute("maxlength", "18");
        var whatsUniqueAboutBusiness = this.form.querySelector("textarea[name='whatsUniqueAboutBusiness']");
        whatsUniqueAboutBusiness.setAttribute("maxlength", "249");
        var problemsInCompany = this.form.querySelector("textarea[name='problemsInCompany']");
        problemsInCompany.setAttribute("maxlength", "249");
        var revenueModel = this.form.querySelector("textarea[name='revenueModel']");
        revenueModel.setAttribute("maxlength", "249");
        var targetMarket = this.form.querySelector("textarea[name='targetMarket']");
        targetMarket.setAttribute("maxlength", "249");
        var competitors = this.form.querySelector("textarea[name='competitors']");
        competitors.setAttribute("maxlength", "249");
        var companyLeadership = this.form.querySelector("textarea[name='companyLeadership']");
        companyLeadership.setAttribute("maxlength", "249");
    };
    FormItemBusinessAwards.prototype.populateProvinces = function () {
        var provinceSelect = this.form.querySelector("select[name=businessAddressProvince]");
        var provinces = this.provincialCityService.getProvices();
        provinces['provinces'].forEach(function (province) {
            var provinceOption = document.createElement("option");
            provinceOption.setAttribute("value", province["value"]);
            provinceOption.appendChild(document.createTextNode(province["name"]));
            provinceSelect.appendChild(provinceOption);
        });
    };
    return FormItemBusinessAwards;
}(Base));
export { FormItemBusinessAwards };



//////////////////
// WEBPACK FOOTER
// ./components-wpbbsa/form-item-business-awards/form-item-business-awards.component.ts
// module id = 839
// module chunks = 0